import { SubcatalogsGetStatisticsBySubcatalogIdResponse } from '@flowio/api-sdk';
import ActionTypes from '../constants/action-types';
import {
  ThunkExtraArguments,
  RootState,
  ThunkDispatcher,
  ThunkResult,
} from '../../../stores/types';
import { LegacyResponse } from '../../../utilities/clients/types/server';
import toLegacyResponse from '../../../utilities/clients/to-legacy-response';
import { PropType } from '../../../types';
import formatErrorResponseV2 from '../../../utilities/format-error-response-v2';

type ResponseType = PropType<SubcatalogsGetStatisticsBySubcatalogIdResponse, 'body'>;

export default function getSubcatalogStatistics(
  organization: string,
  subcatalogId: string,
): ThunkResult<Promise<LegacyResponse<ResponseType>>> {
  return (
    dispatch: ThunkDispatcher,
    getState: () => RootState,
    extra: ThunkExtraArguments,
  ): Promise<LegacyResponse<ResponseType>> => {
    dispatch({
      type: ActionTypes.GET_SUBCATALOG_STATISTICS_REQUEST,
    });

    return extra.api(getState()).subcatalogs.getStatisticsBySubcatalogId({
      organization,
      subcatalog_id: subcatalogId,
    }).then((response) => {
      if (response.ok) {
        dispatch({
          type: ActionTypes.GET_SUBCATALOG_STATISTICS_SUCCESS,
          payload: response.body,
        });
      } else {
        dispatch({
          type: ActionTypes.GET_SUBCATALOG_STATISTICS_FAILURE,
          payload: formatErrorResponseV2(response),
        });
      }
      return toLegacyResponse<ResponseType>(response);
    });
  };
}
